export interface UploadProfilePictureProps {
    onUploadImage: Function;
    imageSrc?: File | undefined;
    imgSrcUrl?: string;
    actions?: ProfilePictureActions[];
    marginLeft?: string;
    showActions?: Function;
    isLarge?: boolean;
}

export interface ProfilePictureActions {
    title: string;
    icon?: string;
    action?: Function;
    actionKey: ProfilePictureInnerActions;
}

export enum ProfilePictureInnerActions {
    REPLACE,
    DELETE
}
